<div class="loader-wrapper">
    <app-loader [isBusy]="isBusy">
        <ng-template>
            <ng-template #template let-anchor>
                <span>{{ anchor.nativeElement.innerText }}</span>
            </ng-template>
            <div
                kendoTooltip
                showOn="none"
                filter=".k-grid"
                [tooltipTemplate]="template"
                (mouseover)="showTooltip($event)">
                <kendo-grid
                    class="mb-2"
                    [data]="itemsGridView"
                    [skip]="itemPage.skip"
                    [pageSize]="itemPage.pageSize"
                    [pageable]="pagingOptions"
                    [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                    [resizable]="true"
                    [sort]="sort"
                    (detailExpand)="expandDetailGrid()"
                    (pageChange)="pageChange($event, pcsApprovals)"
                    (sortChange)="sortChange($event, pcsApprovals)">
                    @if (actionConditions && hasPermission('PcsApprovals.PcsApprovals.Add')) {
                        <ng-template kendoGridToolbarTemplate>
                            <button
                                class="btn btn-sm btn-primary"
                                kendoTooltip
                                title="{{ 'Add' | translate }}"
                                preventMultiClick
                                (click)="openNewApprovalModal()">
                                <fa-icon icon="plus"></fa-icon>
                            </button>
                        </ng-template>
                    }
                    <kendo-grid-column title="{{ 'Id' | translate }}" field="id" [width]="120"></kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Actions' | translate }}"
                        field="actions"
                        [width]="350"
                        [sortable]="false">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            @if (hasPermission('PcsApprovals.PcsApprovals.Edit')) {
                                <div class="approvals-action-buttons">
                                    @if (canUserOrgSendApproval(dataItem)) {
                                        <button
                                            class="btn btn-sm btn-primary mr-2"
                                            (click)="openApprovalModal(dataItem.id)">
                                            <fa-icon [icon]="['fas', 'check']"></fa-icon>
                                            &nbsp;&nbsp;{{ 'Send For Approval' | translate }}
                                        </button>
                                    }
                                    @if (dataItem.canComplete) {
                                        <button
                                            class="btn btn-sm btn-light mr-2"
                                            (click)="changeStatus('complete', dataItem)">
                                            <fa-icon [icon]="['fas', 'check']"></fa-icon>
                                            &nbsp;&nbsp;{{ 'Complete' | translate }}
                                        </button>
                                    }
                                    @if (dataItem.canSend2ndApproval) {
                                        <button
                                            class="btn btn-sm btn-primary mr-2"
                                            (click)="changeStatus('send2ndApproval', dataItem)">
                                            <fa-icon [icon]="['fas', 'dice-two']"></fa-icon>
                                            &nbsp;&nbsp;{{ 'Send for 2nd Approval' | translate }}
                                        </button>
                                    }
                                    @if (dataItem.canSend3rdApproval) {
                                        <button
                                            class="btn btn-sm btn-primary mr-2"
                                            (click)="changeStatus('send3rdApproval', dataItem)">
                                            <fa-icon [icon]="['fas', 'dice-three']"></fa-icon>
                                            &nbsp;&nbsp;{{ 'Send for 3rd Approval' | translate }}
                                        </button>
                                    }
                                    @if (canUserApproveApproval(dataItem)) {
                                        <button
                                            class="btn btn-sm btn-success mr-2"
                                            (click)="changeStatus('approve', dataItem)">
                                            <fa-icon [icon]="['fas', 'check']"></fa-icon>
                                            &nbsp;&nbsp;{{ 'Approve' | translate }}
                                        </button>
                                    }
                                    @if (canUserRejectApproval(dataItem)) {
                                        <button
                                            class="btn btn-sm btn-warning mr-2"
                                            (click)="openRejectionRemarkDialog(dataItem)">
                                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                                            &nbsp;&nbsp;{{ 'Reject' | translate }}
                                        </button>
                                    }
                                    @if (requiresMyApproval(dataItem)) {
                                        <span
                                            class="text-info mr-2"
                                            kendoTooltip
                                            title="{{ 'Requires My Approval' | translate }}">
                                            <fa-icon size="lg" [icon]="['fas', 'info-circle']"></fa-icon>
                                        </span>
                                    }
                                </div>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Type' | translate }}"
                        field="pcsDocumentAndApprovalType.localizedCode"
                        [width]="200">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.pcsDocumentAndApprovalType) {
                                <span>
                                    {{
                                        row.pcsDocumentAndApprovalType.localizedCode +
                                            ' - ' +
                                            row.pcsDocumentAndApprovalType.name
                                    }}
                                </span>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Status' | translate }}"
                        field="pcsDocumentAndApprovalStatus.id"
                        [width]="200">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.pcsDocumentAndApprovalStatus) {
                                <span class="pill" [ngClass]="getClass(row.pcsDocumentAndApprovalStatus.id)">
                                    {{
                                        row.pcsDocumentAndApprovalStatus.localizedCode +
                                            ' - ' +
                                            row.pcsDocumentAndApprovalStatus.name
                                    }}
                                </span>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Organization For Approval' | translate }}"
                        field="forOrganization.code"
                        [width]="200">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.forOrganization) {
                                <span>{{ row.forOrganization.code }} - {{ row.forOrganization.name }}</span>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Created By Organization' | translate }}"
                        field="createdByOrganization.code"
                        [width]="200">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.createdByOrganization) {
                                <span>{{ row.createdByOrganization.code }} - {{ row.createdByOrganization.name }}</span>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="{{ 'Created By' | translate }}" field="createdBy.lastName" [width]="200">
                        <ng-template kendoGridCellTemplate let-row>
                            <span>{{ row.createdBy.firstName + ' ' + row.createdBy.lastName }}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="{{ 'Created Date' | translate }}" field="createdDate">
                        <ng-template kendoGridCellTemplate let-row>
                            <span>{{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Last Modified By' | translate }}"
                        field="lastModifiedBy.lastName"
                        [width]="200">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.lastModifiedBy) {
                                <span>
                                    {{ row.lastModifiedBy.firstName + ' ' + row.lastModifiedBy.lastName }}
                                </span>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Last Modified Date' | translate }}"
                        field="lastModifiedDate"
                        [width]="200">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.lastModifiedDate) {
                                <span>
                                    {{ row.lastModifiedDate | date: 'dd.MM.yyyy HH:mm' }}
                                </span>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Remarks' | translate }}"
                        field="remarks"
                        [style]="{ 'text-align': 'right' }"
                        [width]="100">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.remarks) {
                                <fa-icon [icon]="['far', 'check-square']"></fa-icon>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Attachments' | translate }}"
                        field="hasAttachments"
                        [style]="{ 'text-align': 'right' }"
                        [width]="100">
                        <ng-template kendoGridCellTemplate let-row>
                            @if (row.hasAttachments) {
                                <button
                                    class="btn btn-sm btn-primary"
                                    kendoTooltip
                                    title="{{ 'Attachments' | translate }}"
                                    (click)="openPcsApprovalAttachments(row.id, row.pcsDocumentAndApprovalStatus.id)">
                                    <fa-icon [icon]="['fas', 'paperclip']"></fa-icon>
                                </button>
                            }
                        </ng-template>
                    </kendo-grid-column>
                    <ng-template kendoGridDetailTemplate let-dataItem>
                        <section class="ml-n2">
                            <app-pcs-additional-approval
                                [approvalId]="dataItem.id"
                                [generalActStatusId]="generalActStatusId"
                                [approvalLocation]="approvalLocation"
                                (updateGridData)="updateData($event, dataItem.id)"></app-pcs-additional-approval>
                        </section>
                    </ng-template>
                    <ng-template kendoGridNoRecordsTemplate>
                        <p>{{ 'No records available' | translate }}.</p>
                    </ng-template>
                </kendo-grid>
            </div>
            @if (newApprovalModalOpened) {
                <kendo-dialog
                    title="{{ 'Create new Approval' | translate }}"
                    [minWidth]="800"
                    [maxWidth]="800"
                    [maxHeight]="800"
                    (close)="closeNewApprovalModal()">
                    <div class="row">
                        <div class="col">
                            <kendo-multicolumncombobox
                                textField="name"
                                valueField="id"
                                [data]="newPossibleApprovals"
                                [kendoDropDownFilter]="{
                                    operator: 'contains',
                                    fields: ['id', 'localizedCode', 'name']
                                }"
                                [(ngModel)]="selectedApproval"
                                (selectionChange)="changeCurrentApprovalType($event)">
                                <kendo-combobox-column title="{{ 'Id' | translate }}" field="id" [width]="150">
                                    <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                                        {{ dataItem.id }}
                                    </ng-template>
                                </kendo-combobox-column>
                                <kendo-combobox-column
                                    title="{{ 'Localized Code' | translate }}"
                                    field="localizedCode"
                                    [width]="150">
                                    <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                                        {{ dataItem.localizedCode }}
                                    </ng-template>
                                </kendo-combobox-column>
                                <kendo-combobox-column title="{{ 'Name' | translate }}" field="name">
                                    <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                                        {{ dataItem.name }}
                                    </ng-template>
                                </kendo-combobox-column>
                            </kendo-multicolumncombobox>
                        </div>
                    </div>
                    @if (currentSelectedTypeId !== -1 && getAllAdditionalDataToDisplay().length > 0) {
                        <div class="row mt-2">
                            <div class="col-12">
                                @for (row of getAllAdditionalDataToDisplay(); track row) {
                                    <div>
                                        <app-additional-data-input
                                            #additionalDataInputs
                                            [name]="row.dataName"
                                            [mandatory]="row.dataRole === 'M'"
                                            [disabled]="false"
                                            [dataFormat]="row.dataFormat.toLowerCase()"
                                            [dataType]="getElementFromFormat(row.dataFormat)"
                                            [defaultValue]="null"
                                            [longDisplay]="true"
                                            [dataId]="row.dataRoleId"></app-additional-data-input>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    <kendo-dialog-actions layout="end">
                        <button
                            class="btn btn-sm btn-primary mr-2"
                            preventMultiClick
                            kendoButton
                            [disabled]="isAnyInputRequired() || currentSelectedTypeId === -1"
                            (click)="createNewApproval()">
                            <fa-icon icon="check"></fa-icon>
                            &nbsp;&nbsp;{{ 'Create' | translate }}
                        </button>
                        <button class="btn btn-sm btn-secondary" kendoButton (click)="closeNewApprovalModal()">
                            <fa-icon icon="times"></fa-icon>
                            &nbsp;&nbsp;{{ 'Cancel' | translate }}
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>
            }

            @if (approvalModalOpened) {
                <kendo-dialog
                    title="{{ 'Select organization to send Approval to: ' | translate }}"
                    [minWidth]="800"
                    (close)="closeStatusChangeDialogs()">
                    <div class="row">
                        <kendo-combobox
                            class="no-margin-input"
                            placeholder="{{ 'For Organization' | translate }}"
                            textField="name"
                            valueField="id"
                            [allowCustom]="false"
                            [data]="possibleOrganizationSelections"
                            [value]="sendApprovalDefaultOrganization"
                            [filterable]="true"
                            (selectionChange)="changeSelectedOrganization($event)"
                            (filterChange)="searchOrganizations($event)"></kendo-combobox>
                    </div>
                    <kendo-dialog-actions layout="end">
                        <button
                            class="btn btn-sm btn-primary mr-2"
                            preventMultiClick
                            kendoButton
                            [disabled]="!selectedOrganization"
                            (click)="submitApprovalActionStatusChange()">
                            <fa-icon [icon]="['fas', 'check']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Submit' | translate }}
                        </button>
                        <button class="btn btn-sm btn-secondary" kendoButton (click)="closeStatusChangeDialogs()">
                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Cancel' | translate }}
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>
            }

            @if (showChangeOrganization) {
                <kendo-dialog
                    title="{{ 'Select organization to send Approval to: ' | translate }}"
                    [minWidth]="1150"
                    (close)="closeStatusChangeDialogs()">
                    @if (showChangeOrganization) {
                        <div class="row">
                            <kendo-combobox
                                class="no-margin-input"
                                placeholder="{{ 'For Organization' | translate }}"
                                textField="name"
                                valueField="id"
                                [allowCustom]="false"
                                [data]="possibleOrganizationSelections"
                                [value]="sendApprovalDefaultOrganization"
                                [filterable]="true"
                                (selectionChange)="changeSelectedOrganization($event)"
                                (filterChange)="searchOrganizations($event)"></kendo-combobox>
                        </div>
                    }
                    <kendo-dialog-actions layout="end">
                        <button
                            class="btn btn-sm btn-primary mr-2"
                            preventMultiClick
                            kendoButton
                            [disabled]="!selectedOrganization"
                            (click)="newStateTransition()">
                            <fa-icon [icon]="['fas', 'check']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Submit' | translate }}
                        </button>
                        <button class="btn btn-sm btn-secondary" kendoButton (click)="closeStatusChangeDialogs()">
                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Cancel' | translate }}
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>
            }

            @if (rejectionRemarkDialogOpened) {
                <kendo-dialog
                    title="{{ 'Add Rejection Remark' | translate }}"
                    [minWidth]="550"
                    (close)="closeRejectionRemarksDialog()">
                    <div class="row">
                        <span>{{ 'Remark: ' | translate }}</span>
                    </div>
                    <div class="row">
                        <kendo-textarea [rows]="3" [(ngModel)]="remarkValue"></kendo-textarea>
                    </div>
                    <kendo-dialog-actions layout="end">
                        <button
                            class="btn btn-sm btn-primary mr-2"
                            preventMultiClick
                            kendoButton
                            (click)="submitRejectionRemark()">
                            <i class="fa fa-check"></i>
                            &nbsp;&nbsp;{{ 'Submit' | translate }}
                        </button>
                        <button class="btn btn-sm btn-secondary" kendoButton (click)="closeRejectionRemarksDialog()">
                            <i class="fa fa-times"></i>
                            &nbsp;&nbsp;{{ 'Cancel' | translate }}
                        </button>
                    </kendo-dialog-actions>
                </kendo-dialog>
            }
        </ng-template>
    </app-loader>
</div>
